enum AssetType {
    AUTOMOBILE = 'automobile',
    POWERSPORTS_VEHICLE = 'powersports_vehicle',
    RECREATIONAL_VEHICLE = 'recreational_vehicle',
    MARINE = 'marine',
    OUTDOOR_POWER_EQUIPMENT = 'outdoor_power_equipment',
}

export default AssetType
